import { render, staticRenderFns } from "./saveButtons.vue?vue&type=template&id=ad574f9c&scoped=true&"
import script from "./saveButtons.vue?vue&type=script&lang=js&"
export * from "./saveButtons.vue?vue&type=script&lang=js&"
import style0 from "./saveButtons.vue?vue&type=style&index=0&id=ad574f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad574f9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
